import styled from "styled-components";
import { breakpoint } from "../../helpers/styles/breakpoints";
import bg from "../../assets/images/estilo-aprendizaje/fondoestiloaprendizaje.png";

export const EstiloAprendizajeHeader = styled.header`
  position: fixed;
  height: 100px;
  right: 0;
  left: 0;
  top: 0;
  color: white;
  padding: 10px;
  z-index: 4;

  p.small-text {
    font-size: 15px;
    margin: 0;
    margin-bottom: 10px;
  }

  .onlyPc {
    display: inline;
  }

  .onlyMobile {
    display: none;
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    .onlyPc {
      display: none;
    }
    .onlyMobile {
      display: inline;
    }
  }
`;

export const TopHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url(${bg});
  background-size: contain;
`;

export const EstiloAprendizajeMainContainer = styled.div`
  background-color: #003a4b;
  color: white;
  position: relative;
  padding: 40px;
  min-height: calc(100vh - 80px);
  background-image: url(${bg});
  background-size: cover;
`;

export const RowContainer = styled.span`
  display: flex;
  gap: 30px;
  justify-content: space-between;
  color: white;
  flex-flow: row;

  hr {
    display: none;
  }

  @media only screen and (max-width: ${"768px"}) {
    flex-flow: column;

    hr {
      display: block;
      width: 100%;
    }
  }
`;

export const AllItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
`;

export const ItemContainer = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 5px;
  background-color: #003a4b;
  margin-top: 5px;
  align-items: center;
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
  font-family: "poppins semibold";
  width: 25%;

  span {
    font-size: 16px;
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    width: 100%;
    background-color: #ededed;
    color: #013c4e;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    span {
      font-size: 12px;
    }
  }

  input {
    width: 30px;
    height: 30px;
    font-size: 15px;
    background-color: #00727e;
    cursor: text;
    color: #fff;
    text-align: center;
    border: none;

    @media only screen and (min-width: 0) and (max-width: 768px) {
      background-color: #8da3b1;
      color: #013c4e;
      font-weight: 600;
      font-size: 20px;
    }
  }
`;

export const FirstItemContainer = styled(ItemContainer)`
  width: 5px;
  background-color: transparent;
  box-shadow: none;
  padding: 0;

  span {
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    width: 100%;
    span {
      font-size: 25px;
      text-align: center;
      width: 100%;
      display: block;
      color: #ededed;
    }
  }
`;

export const ImageButton = styled.img`
  height: 40px;
  cursor: pointer;
`;

type ImageButtonContainerProps = {
  currentStep: number;
  canCalculate: boolean;
};

export const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 10px;
  height: 80px;
  display: flex;
  justify-content: end;
  padding-right: 40px;
  background-image: url(${bg});
  background-size: cover;
`;

export const ImageButtonContainer = styled.a<ImageButtonContainerProps>`
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #00abc8;
  text-decoration: ${({ currentStep, canCalculate }) =>
    currentStep === 2 && !canCalculate ? "none" : "underline"};
  gap: 10px;
  min-width: 225px;

  > img {
    max-height: 40px;
    display: ${({ currentStep, canCalculate }) =>
      currentStep === 2 && !canCalculate ? "none" : "block"};
  }

  > span {
    font-weight: 600;
    font-size: ${({ currentStep, canCalculate }) =>
      currentStep === 2 && !canCalculate ? "14px" : "25px"};
    color: ${({ currentStep, canCalculate }) =>
      currentStep === 2 && !canCalculate ? "#FFF" : "#00abc8"};
    cursor: ${({ currentStep, canCalculate }) =>
      currentStep === 2 && !canCalculate ? "text" : "pointer"};
  }
`;

export const AffirmationContainer = styled.div`
  margin-top: 120px;
  margin-bottom: 100px;
  min-height: calc(100vh - 280px);

  @media only screen and (min-width: 769px) {
    margin-top: 120px;
    margin-bottom: 100px;
  }

  .estilo {
    color: #003a4b;
    font-size: 1.2rem;

    p {
      margin: 0;

      &.active {
        font-weight: 600;
        font-size: 1.3rem;
        color: rgb(187 126 19);
      }
    }
  }
`;

export const ExplanationContainer = styled(AffirmationContainer)`
  font-size: 15px;
  margin: 25px 65px;

  h1 {
    margin: 0;
    color: white;

    span {
      position: relative;
      span {
        z-index: 3;
        margin-left: 10px;
      }
      div {
        background-color: #00a8c4;
        width: 100%;
        position: absolute;
        height: 100%;
        left: -8px;
        display: inline;
        z-index: 2;
      }
    }
  }

  h6 {
    margin: 15px 0;
    color: white;
    font-size: 1rem;
    font-weight: 400;
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    margin: 5px 15px;
  }
`;

export const InstruccionesContainer = styled.div`
  padding: 5px;
  color: #fff;
  font-size: 18px;
  margin-top: 10px;

  min-height: calc(100vh - 40px);

  p {
    margin: 5px;
    font-family: "poppins light";
    margin-bottom: 15px;
    text-align: justify;
    text-justify: inter-word;

    &.example {
      font-weight: 600;
    }
  }

  .onlyPc {
    display: inline;
  }

  .onlyMobile {
    display: none;
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    .onlyPc {
      display: none;
    }
    .onlyMobile {
      display: inline;
    }
  }
`;

export const IntrospeccionLabel = styled.div`
  font-weight: 600;
  font-size: 24px;
`;

export const IntrospeccionName = styled.div`
  font-size: 30px;
  font-weight: 600;
  line-height: 1;

  span {
    color: #b6bc21;
  }
`;

export const LogoContainer = styled.div`
  img {
    &:first-of-type {
      margin-right: 20px;
    }
  }

  .logoleft {
    height: 40px;
    margin-right: 50px;
  }

  .logoright {
    height: 50px;
  }

  @media only screen and (min-width: 0) and (max-width: 768px) {
    .logoleft {
      height: 25px;
      margin-right: 0;
    }

    .logoright {
      height: 35px;
    }
  }
`;
